import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface FeaturedArticlesProps {
  articles: Article[];
}

export default function FeaturedArticles({ articles }: FeaturedArticlesProps) {
  return (
    <section className="py-10 md:py-14 bg-background-100/70">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">编辑精选</h2>
            <p className="text-sm text-foreground-500 mt-1">每日精选深度好文，不容错过的精彩内容</p>
          </div>
          <Link
            to="/category/hot-tracking"
            className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-2.5 text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}